import { TnError } from './TnError';

/**
 * This exception is thrown anytime a family is queried, but we're unable to get it.
 */
export class TnErrorFoundryDataNotProvided extends TnError<
    Record<string, never>
> {
    public type = 'foundryNotFound';
    constructor() {
        super('No data provided to find foundry', Object.create(null));
    }
}
